import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { InputComponent } from "../input/input.component";
import { Content } from "@xanadu/model";

@Component({
    selector: 'app-formula',
    templateUrl: './formula.component.html',
    styleUrls: ['./formula.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormulaComponent extends InputComponent {
    content = input<Content>();

    public onFormula(): any {
        if (this.formGroup() && this.meta().script) {
            const formControl = this.formControl();

            try {
                const formula = this.runFormula();
                if (formula != formControl?.value) {
                    formControl?.setValue(formula);
                    formControl?.markAsDirty();
                }
            } catch (e) {
                formControl?.setErrors({ 'script': true });
            }
        }
        return false;
    }

    public onClear() {
        const formControl = this.formControl();

        formControl?.setValue('');
        formControl?.markAsDirty();
    }

    private runFormula() {
        const content = this.content();
        const source = { _id: content?._id, name: content?.name, data: { ...this.formGroup()?.value } };
        return new Function(`return (${this.meta().script});`)()(source);
    }
}
